/**
 * Vorschau des gestalteten Schriftzugs im Warenkorb.
 *
 * Das Produkt hat kein Foto, es entsteht ja erst nach der Bestellung. Statt
 * einer leeren Bildspalte holt der Warenkorb dieselbe Vorschau, die der
 * Konfigurator zeigt: Der Aufruf steht als Adresse am Element, die Auswahl
 * steckt in den versteckten Properties der Position.
 *
 * Das SVG wird eingehängt und nicht als <img> gesetzt: Ein Bild lädt die
 * Materialfotos im SVG nicht nach, jedes Holz sähe gleich aus.
 */
(function () {
  if (!window.fetch) return;

  var AUSWAHL = '[data-tw-vorschau]';
  /** Adresse → SVG, damit ein neu aufgebauter Warenkorb nichts nachlädt */
  var gemerkt = {};
  var geplant = false;

  function setze(feld, svg) {
    feld.innerHTML = svg;
    feld.setAttribute('data-tw-stand', 'fertig');
  }

  function hole(feld) {
    var stand = feld.getAttribute('data-tw-stand');
    if (stand === 'fertig' || stand === 'laeuft') return;

    var adresse = feld.getAttribute('data-tw-vorschau');
    if (!adresse) return;

    if (gemerkt[adresse]) {
      setze(feld, gemerkt[adresse]);
      return;
    }

    feld.setAttribute('data-tw-stand', 'laeuft');
    fetch(adresse)
      .then(function (antwort) {
        if (!antwort.ok) throw new Error(String(antwort.status));
        return antwort.text();
      })
      .then(function (svg) {
        // Nur was wirklich ein SVG ist, kommt in die Seite
        if (svg.indexOf('<svg') !== 0) throw new Error('kein SVG');
        gemerkt[adresse] = svg;
        setze(feld, svg);
      })
      .catch(function () {
        // Ohne Vorschau bleibt der Platzhalter stehen, der Warenkorb bleibt heil
        feld.setAttribute('data-tw-stand', 'fehler');
      });
  }

  function alle() {
    geplant = false;
    var felder = document.querySelectorAll(AUSWAHL);
    for (var i = 0; i < felder.length; i++) hole(felder[i]);
  }

  function baldAlle() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(alle);
  }

  alle();
  document.addEventListener('DOMContentLoaded', alle);

  // Dawn baut die Positionen bei jeder Mengenänderung neu auf, die
  // eingehängten Vorschauen sind danach weg.
  var korb = document.getElementById('main-cart-items');
  if (korb && window.MutationObserver) {
    new MutationObserver(baldAlle).observe(korb, { childList: true, subtree: true });
  }
})();
